import {Display} from "./Display";
import {Form} from "./Form";
import {Load} from "./Load";
import {Video} from "./Video";

// noinspection JSUnresolvedVariable,JSUnresolvedFunction
export class Basic
{
    static init()
    {
        Basic.base = '/';
        Basic.lang = 'de';
        Basic.resizeTimer = 0;
        Basic.ise = (document.body.dataset.ise === 'on');
        Basic.transitionTimer = 400;
    }

    static add_clickEvent()
    {
        document.body.addEventListener('click',e =>
        {
            let el = e.target;

            if(el.classList.contains('ise') || el.closest('.ise'))
            {
                return false;
            }
            else if(el.closest('.w__js-button'))
            {
                el = el.closest('.w__js-button');
            }

            if(el.classList.contains('w__js-button') &&
               el.dataset.f)
            {
                switch(el.dataset.f)
                {
                    case 'article-close':
                        e.preventDefault();
                        Load.close(el);
                        break;

                    case 'form-toggle-condition':
                        Form.toggle_condition(el);
                        break;

                    case 'load':
                        e.preventDefault();
                        Load._process(el.href);
                        break;

                    case 'video':
                        e.preventDefault();
                        new Video(el);
                        break;

                    default:
                        console.log('Missing case: ' + el.dataset.f);
                }
            }
        });
    }

    static adjust_imagePath(imgSrc, sizeX, sizeY)
    {
        sizeX *= Display.dpi;
        sizeY *= Display.dpi;

        let srcPath = '',
            targetPath = '';

        if(imgSrc.match(/\/full\//))
        {
            if(sizeY <= 680)
            {
                targetPath = '510x680';
            }
            else if(sizeY <= 1000)
            {
                targetPath = '750x1000';
            }
            else
            {
                targetPath = '1200x1600';
            }
            targetPath = '/full/' + targetPath + '/';
            srcPath = '/full/510x680/';
        }

        else if(imgSrc.match(/\/tile\//))
        {
            if(sizeX <= 352)
            {
                targetPath = '352x198';
            }
            else if(sizeX <= 512)
            {
                targetPath = '512x288';
            }
            else if(sizeX <= 800)
            {
                targetPath = '800x450';
            }
            else
            {
                targetPath = '1200x675';
            }
            targetPath = '/tile/' + targetPath + "/";
            srcPath = '/tile/352x198/';
        }

        return imgSrc.replace(srcPath, targetPath);
    }

    static do_afterLoad()
    {
        // activate forms
        let forms = document.body.querySelectorAll('.w__form:not(.active)');
        for(let i=0; i<forms.length; i++)
        {
            new Form(forms[i]);
        }
    }

    static process_resize()
    {
        Display.analyze();
    }
}

